
import React, { useState, useContext, useEffect } from 'react';
import '../../../styles/casedetails.css';
import { Outlet, Link, useNavigate, Navigate } from 'react-router-dom';
import { ShareContext } from '../../../context/ShareContext'
import * as Constants from '../../../constants';
import JisButton from '../../controls/jisButton';
import JisDialog from '../../dialog';
import DynamicIcon from '../../dynamicicon';
import JisDialogForm from '../../formdialog';


function ViewPayments({caseId, payments=null, isAction=false}) {
    const navigate = useNavigate();
  const {  activePage, token, profile,frequentData, setIsExpired} = useContext(ShareContext);
     
        const [loading, setLoading] =useState(false);
        const [pays, setPays] = useState(payments);
        const [payConfirmed, setPayConfirmed] = useState(false);
        const [pay, setPay]=useState(null);
        const [feeid, setFeeid] = useState(null);
        useEffect(() => {
            
              /* if(payments==null){
               onLoad();
              } */
             console.log('before profile');
            console.log(profile);
          }, [payments]);
  
           const onLoad= async()=>{
              //for account registration
              try {
                setLoading(true);
                  const resp = await fetch(`${Constants.apiUrl}/filing/case-details/${caseId}/payments`, { 
                    method: 'GET',
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${token}`,
                    },
                  });
                  
                  const data = await resp.json();
                  if(data.code==0){
                    setPays(data.payments);
                  } else if(data.code==-10){
                      setIsExpired(true);
                  }
                } catch (error) {
                  setLoading(false);
                  console.error(error);
                  
                }
          }

          const onMakePayment=(pay)=>{
              navigate(`/payment/${pay.id}`);
          }
          const onVerifyPayment=async(fid, index)=>{
            //this to continue the process for cases that looks like it
            setLoading(true);
                      setFeeid (fid);       
            try {
            
              const resp = await fetch(`${Constants.apiUrl}/payment/payment-verify-both/${fid}`, {
                method: 'POST',
                
                headers: {
                  'Content-Type': 'application/json, text/plain',
                  'Authorization': `Bearer ${token}`,
                },
              });
              
              const data = await resp.json();
              setLoading(false);
              console.log(data);
              if (data.code === 0) {
                  setPay(data.payreceipt);
                  setPayConfirmed(true);
                 // get specific index
                  const updated = pays.map(pay =>
                      pay.id === fid ? { ...pay, isPaid: true, } : pay
                    );
                    setPays(updated);
              }else {   
                //setErr("We cannot confirm the payment");
                navigate(`/payment/${fid}`);
              }
            } catch (error) {
              setLoading(false);
              console.error(error);
              // setErr(Constants.serverErr);
              // onMove();
            }
          }
 const onRevenueReceipt=()=>{
        window.open(pay?.receipt, "_blank");

    }

    const onUpload=()=>{
        navigate(`/document-upload/${feeid}`)
    }
  return (
    <div>
        <div  className='table'>
        <div class="section-cases">
          <span>Payments </span>
        </div>
        <table className='case-table'>
          <thead>
            <tr>
              <th>Fee Type</th>
              <th>Amount</th>
              <th>Date</th>
              <th>Web Guid</th>
              <th>Paid Status</th>
              <th>Revenue Receipt</th>
              <th>Judiciary Receipt</th>
             <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {pays?.map((opt,ind) => ( 
              <tr key={opt.id}>
              <td> {opt.associatedFeeId==null? Constants.getItemById(frequentData?.feetypes,opt.caseFeeTypeId)?.description : 'Review Fee'}</td>
              <td>{Constants.formatCurrency(opt.fee) }</td>
               <td> {Constants.momentDate(opt.createdOn).format('DD MMM, YYYY')}</td>
               <td>{opt.webGuid}</td>
              <td>{opt.isPaid? 'Paid':'Unpaid'}</td>
              <td>{opt.receiptUrl!=null && <><a href={opt.receiptUrl} target='_blank'>Revenue Receipt</a></>} </td>
               <td> {opt.isPaid && <a href={`${Constants.baseurl}/receipt/${opt.id}`} target='_blank'>Judiciary Receipt</a>} </td>
             {profile.id==opt.party?.legalCounselId?<td>{(!opt.isPaid && opt.webGuid==null) && <JisButton onClick={()=>onMakePayment(opt)}>Make Payment</JisButton>} 
                  {(opt.isPaid==false && opt.webGuid!=null) && <JisButton onClick={()=>onVerifyPayment(opt.id,ind)}>Sync Payment</JisButton>}
                  </td>:<td></td>} 
              
            </tr>          
            ))}
            
          </tbody>
        </table>
      </div>
{payConfirmed && <JisDialogForm title="Payment" onClose={()=>setPayConfirmed(false)}>
  
    <div class="receipt-section">
        <div class="icons">
       <DynamicIcon iname="done" size={60} />
        </div>
        
        <h3>Payment Successful</h3>
        <div className="payment-details">
       <div className="row"><strong>Payer ID:</strong><span>{pay?.payerId}</span></div>
    <div className="row"><strong>Payer Name:</strong><span>{pay?.payerName}</span></div>
    <div className="row"><strong>Transaction Number:</strong><span>{pay?.paymentTrans}</span></div>
    <div className="row"><strong>Date and Time of Transaction:</strong><span>{pay?.paymentDate}</span></div>
    <div className="row"><strong>Receiving HOA Name:</strong><span>{pay?.agencyName}</span></div>
    <div className="row"><strong>Payment Details:</strong><span>Success</span></div>
 
    <div className="row"><strong>Bill Reference Number:</strong><span>{pay?.reference}</span></div>
   {/*  <div className="row"><strong>Address:</strong><span>20B, Adeola Estate, Ogba, Lagos</span></div> */}
    <div className="row"><strong>Amount:</strong><span>₦ {Constants.formatCurrency(pay?.amountPaid)}</span></div>
    <div className="row"><strong>Agency:</strong><span>{pay?.agencyCode}</span></div>
    <div className="row"><strong>Revenue Code:</strong><span>{pay?.revenueCode}</span></div>
  </div>
  <div class="receipt-buttons">
  <JisButton>Judiciary Receipt</JisButton>
  <JisButton onClick={onRevenueReceipt}>Revenue Receipt</JisButton>
  <JisButton onClick={onUpload}>Upload Document</JisButton>
</div>
    </div>
  </JisDialogForm>}
    </div>
  );
}

export default ViewPayments;